import { useQuery } from "react-query";
import { API_URL } from "../../../../BaseUrlApi/Url";
import API from "@Config/axios";

export const useGetCity = (cityId) => {
  return useQuery(
    ["city", cityId],
    async () => {
      if (!cityId) return null;
      const response = await API.get(
        `${API_URL}/regions/cities?id=${cityId}`
      );
      return response.data.cities?.name || "-";
    },
    { enabled: !!cityId }
  );
};
